import { render, staticRenderFns } from "./Encuestas-edit.vue?vue&type=template&id=64b4156f&scoped=true&"
import script from "./Encuestas-edit.vue?vue&type=script&lang=js&"
export * from "./Encuestas-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b4156f",
  null
  
)

export default component.exports